import get from "lodash/get";

import moment from "moment";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal-new";
import DateInput from "../inputs/date-input";
import { DATE_FORMATS } from "../../constants";
import { getValidDates } from "../../utils/date-helpers";
import { RillContext, useRillContext } from "../../rill/RillReact/share/base";

const { DATE_PICKER_FORMAT, DATE_DAY_FORMAT } = DATE_FORMATS;

const CalendarMoveWorkoutModal = (props) => {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  const { activeExercises, query } = locals;
  const [validDates, setValidDates] = useState(getValidDates(activeExercises));

  const dateValidator = (pickerDate) => {
    const formattedPickerDate = moment(pickerDate).format(DATE_DAY_FORMAT);

    return validDates[formattedPickerDate];
  };

  const activeDay = moment.utc(query.day, DATE_DAY_FORMAT).startOf("day");
  const exportDate = moment
    .utc(get(query, "day"), DATE_DAY_FORMAT)
    .format(DATE_PICKER_FORMAT);

  return (
    <form
      action={`/actions/exercise/move-day?proxyAthlete=${query.athlete}&reqSource=calendar`}
      method="POST"
      data-noreset
    >
      <input type="hidden" name="type" value="move" />
      <input type="hidden" name="from" value={activeDay.toJSON()} />

      <Modal
        className="Move-Workout export-workout"
        title={t("calendarMoveWorkout.title")}
        toClear={["day"]}
      >
        <div className="body">
          <label htmlFor="">{t("calendarMoveWorkout.todaysDate")}</label>
          <p className="s1">{activeDay.format(DATE_PICKER_FORMAT)}</p>

          <label htmlFor="to" className="mt-6">
            {t("calendarMoveWorkout.moveWorkoutTo")}
          </label>
          <DateInput
            name="to"
            defaultValue={exportDate}
            dateValidator={(date) => dateValidator(date, locals)}
            placeholder={t("calendarMoveWorkout.selectDate")}
          />
        </div>

        <footer>
          <a
            role="button"
            data-button-type="text-white"
            data-action="cancel"
            href="/actions/refresh?modal[type]=&day="
          >
            {t("common:cancel")}
          </a>
          <button role="button" data-button-type="primary" type="submit">
            {t("calendarMoveWorkout.move")}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default CalendarMoveWorkoutModal;
